import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetPortfolios = function () {
    return useApiCall(function (signal) { return api.portfolio.apiPortfolioDataGet({ signal: signal }); }, [], true, []);
};
